import { connect } from 'react-redux'
import * as processAction from '../../../process/state/instance-detail/action'
import * as processSelector from '../../../process/state/instance-detail/selector'
import DeliveryTrackingNumberWidget from './DeliveryTrackingNumberWidget'
import {getProviderUrl} from '../../../logistic/state/list/action.js'


const mapStateToProps = (state, props) => {
    return {
        context: processSelector.selectProcessContext(state),
    }
}

const mapDispatchToProps = {
    changeProcessContext: processAction.changeProcessContext,
    saveProcessContext: processAction.saveProcessContext,
    getProviderUrl: getProviderUrl,
}

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryTrackingNumberWidget)



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/task-widget/DeliveryTrackingNumberWidgetContainer.js